const MsgAlert = ({img="" , title="" , text=""}) => {

  return (
    <div className="container">
      <div className="row">
        <div className="col-12 col-md-8 offset-md-2 message">
          <img loading="lazy" data-src={img} alt="note" width={100} />
          <h4>{title}</h4>
          <p>{text}</p>
        </div>
      </div>
    </div>
  );
}

export default MsgAlert;